import React from 'react';
import DashboardPage from '../components/DashboardPage';

const Login: React.FC = () => {
  return <DashboardPage />;
};

export default DashboardPage;